export default __webpack_public_path__ + "static/robotto-de26581669fe91425efb3af98e9f8f10.webp";